import { gql } from 'apollo-angular';
import { Page } from '../../shared/entities/page/page';

import { MobileDevice } from '../../shared/entities/mobile-device/mobile-device';


export const MOBILE_DEVICES_QUERY = gql`
query mobileDevicesQuery(
  $pageNumber: Int,
  $pageSize: Int,
  $sortProperty: String,
  $sortDirection: String,
  $appVersion: String)
{
  mobileDevices: getMobileDevicesPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection},
      appVersion: $appVersion
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
        id
        appVersion
        lastSeenDateTime
        platform
        model
        name
        bugfenderDeviceUrl
        user{
          id
          firstName
          lastName
        }
        permissions
        androidSdk
        createdDateTime
        uploads{
          id
          type
          uri
          state
          startDateTime
          retryCount
          retryEarliestBeginDateTime
          latestFailedDateTime
          lastHttpStatusCode
          lastErrorCode
          expiryDateTime
          successDateTime
        }
        updateState
      }
  }
}
`;

export interface MobileDevicesQueryResponse {
  mobileDevices: Page<MobileDevice>;
  loading: boolean;
}
